// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__udXPn","title":"ClientInsurance_title__2FeUV","itemText":"ClientInsurance_itemText__1xky1"};